import defaultHandImageMovingRight from 'IMGS/hands/Rosie1.png';
import defaultHandImageMovingLeft from 'IMGS/hands/Rosie2.png';

export default function getCursorResourcesAndMetadata(cursors, cursorId) {
  const noCursor = {
    resources: [],
    handOffsetX: 0,
    handOffsetY: 0
  };

  if (cursorId === -1) {
    return noCursor;
  }

  if (cursorId === 'default') {
    return {
      resources: [defaultHandImageMovingRight, defaultHandImageMovingLeft],
      handOffsetX: 65,
      handOffsetY: -35
    };
  }

  const cursorData = cursors.find(cursor => cursor.id === cursorId);

  if (!cursorData) {
    return noCursor;
  }

  const attributes = new window.DOMParser()
    .parseFromString(cursorData.metadata, 'text/xml')
    .getElementsByTagName('customHand')[0].attributes;
  const resources = Object.entries(cursorData.resources)
    .map(([k, v]) => {
      if (v.type === 'thumbnail') {
        return null;
      }

      return v.url;
    })
    .filter(Boolean);

  return {
    resources,
    handOffsetX: attributes.offset1X.value,
    handOffsetY: attributes.offset1Y.value
  };
}
